import {
  Sidebar,
  SidebarBody,
  SidebarFooter,
  SidebarHeader,
  SidebarSection,
} from './Sidebar';
import SettingsMenu from 'templates/Settings/Nav/SettingsMenu';
import {
  faRightFromBracket,
  faAnglesRight,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { requestToLogout } from 'xstate/actors/AuthActor';
import { closeSidebar } from 'xstate/actors/SidebarActor';
import { useTranslations } from 'next-intl';

const SettingsSidebar = () => {
  const t = useTranslations();

  return (
    <Sidebar>
      <SidebarHeader className="border-none pb-0">
        <div className={styles.titleRow}>
          <h1 className={styles.title}>{t('settingsNav.title')}</h1>
          <button
            type="button"
            aria-label={t('sidebar.closeNavigation')}
            onClick={closeSidebar}
            className={styles.collapse}
          >
            <FontAwesomeIcon icon={faAnglesRight} className="text-lg" />
          </button>
        </div>
      </SidebarHeader>

      <SidebarBody className="pt-0">
        <SidebarSection>
          <SettingsMenu />
        </SidebarSection>
      </SidebarBody>

      <SidebarFooter>
        <button
          type="button"
          onClick={() => requestToLogout()}
          className={styles.signOut.container}
        >
          <FontAwesomeIcon
            icon={faRightFromBracket}
            className={styles.signOut.icon}
            aria-hidden="true"
          />
          <span className={styles.signOut.label}>
            {t('accountMenu.signOut')}
          </span>
        </button>
      </SidebarFooter>
    </Sidebar>
  );
};

export default SettingsSidebar;

const styles = {
  titleRow: 'flex items-center justify-between',
  title: 'text-xl font-bold text-ink-primary px-2 mb-0',
  collapse:
    'flex items-center justify-center h-9 w-9 rounded-full text-ink-primary hover:bg-ink-secondary/10',
  signOut: {
    container:
      'flex flex-row items-center gap-3 px-3 py-2.5 rounded-lg w-full text-left hover:bg-mf-red-500/10',
    icon: 'fa-fw w-5 text-mf-red-600 dark:text-mf-red-400',
    label: 'text-[15px] text-mf-red-600 dark:text-mf-red-400',
  },
};
